(() => {
  class StickyAddToCart extends HTMLElement {
    connectedCallback() {
      this.mainSection = document.querySelector('#main [data-section-type="product"]');
      if (!this.mainSection) return;

      this.realButton = this.mainSection.querySelector('.product-form__add-button');
      this.realButtons = this.mainSection.querySelector('.product-form__buy-buttons');
      this.mainPrice = this.mainSection.querySelector('.price-list');

      this.stickyButton = this.querySelector('[data-sticky-add]');
      this.stickyPrice = this.querySelector('[data-sticky-price]');

      if (!this.realButton || !this.realButtons) return;

      this.onStickyClick = this.onStickyClick.bind(this);
      this.stickyButton.addEventListener('click', this.onStickyClick);

      this.setupVisibility();
      this.setupHeightVar();
      this.setupSync();
      this.syncButton();
      this.syncPrice();
    }

    disconnectedCallback() {
      this.mutationObserver?.disconnect();
      this.resizeObserver?.disconnect();
      this.stickyButton?.removeEventListener('click', this.onStickyClick);
      window.removeEventListener('scroll', this.onVisibilityChange);
      window.removeEventListener('resize', this.onVisibilityChange);
      window.cancelAnimationFrame(this.visibilityFrame);
      this.visibilityFrame = null;
    }

    onStickyClick(event) {
      event.preventDefault();
      if (this.realButton.disabled) return;
      this.realButton.click();
    }

    setupVisibility() {
       this.onVisibilityChange = () => {
        if (this.visibilityFrame) return;

        this.visibilityFrame = window.requestAnimationFrame(() => {
          this.visibilityFrame = null;
          const realButtonRect = this.realButton.getBoundingClientRect();
          this.hidden = realButtonRect.bottom > this.getStickyHeaderOffset();
        });
      };

      window.addEventListener('scroll', this.onVisibilityChange, { passive: true });
      window.addEventListener('resize', this.onVisibilityChange);
      this.onVisibilityChange();
    }

    getStickyHeaderOffset() {
      const rootStyles = window.getComputedStyle(document.documentElement);
      const cssHeaderHeight = parseFloat(rootStyles.getPropertyValue('--header-height')) || 0;
      const cssAnnouncementHeight = parseFloat(rootStyles.getPropertyValue('--announcement-bar-height')) || 0;
      const stickyHeader = document.querySelector('.shopify-section--header, .header');
      const headerRect = stickyHeader ? stickyHeader.getBoundingClientRect() : null;
      const visibleHeaderBottom = headerRect && headerRect.top <= 0 ? headerRect.bottom : 0;

      return Math.max(cssHeaderHeight, cssAnnouncementHeight, visibleHeaderBottom, 0) + 12;
    }

    setupHeightVar() {
      this.updateHeightVar = this.updateHeightVar.bind(this);
      this.resizeObserver = new ResizeObserver(this.updateHeightVar);
      this.resizeObserver.observe(this);
      this.updateHeightVar();
    }

    updateHeightVar() {
      document.documentElement.style.setProperty('--sticky-atc-height', `${this.offsetHeight}px`);
    }

    setupSync() {
      this.mutationObserver = new MutationObserver(() => {
        this.syncButton();
        this.syncPrice();
      });
      this.mutationObserver.observe(this.mainSection, {
        subtree: true,
        childList: true,
        attributes: true,
        characterData: true,
        attributeFilter: ['disabled', 'class'],
      });
    }

    syncButton() {
      const disabled = this.realButton.disabled || this.realButton.hasAttribute('disabled');
      this.stickyButton.disabled = disabled;
      this.stickyButton.classList.toggle('button--disabled', disabled);
      const label = this.realButton.textContent.trim();
      if (label) this.stickyButton.textContent = label;
    }

    syncPrice() {
      if (this.mainPrice && this.stickyPrice) {
        this.stickyPrice.innerHTML = this.mainPrice.innerHTML;
      }
    }
  }

  if (!window.customElements.get('sticky-add-to-cart')) {
    window.customElements.define('sticky-add-to-cart', StickyAddToCart);
  }
})();